angular.module('gym.membership-plans').controller('NewMembershipPlanCtrl', ["$scope", "$state", "$window", "flash", "loadingAnimation", "isInteger", "MembershipIntervalUnits", "MembershipPlanService", "fromPlan", "membershipPlanCategories", "MembershipPlans", "GTMService", "eventTypes", "gradingStyles", function($scope, $state, $window, flash, loadingAnimation, isInteger, MembershipIntervalUnits, MembershipPlanService, fromPlan, membershipPlanCategories, MembershipPlans, GTMService, eventTypes, gradingStyles) {
  var prefillAllowRecurringBookings;
  $scope.membershipPlan = MembershipPlanService.build(fromPlan.plain());
  $scope.membershipPlanCategories = membershipPlanCategories;
  $scope.membership_interval_units = MembershipIntervalUnits;
  $scope.eventTypes = eventTypes;
  $scope.gradingStyles = gradingStyles;
  GTMService.trackPage('Add Membership Plan');
  prefillAllowRecurringBookings = function() {
    var plan;
    plan = $scope.membershipPlan;
    if (!plan.id && !$scope.gym.gym_config.recurring_bookings_feature_enabled && (plan.classes_unlimited || (plan.classes_limit > 0 && plan.classes_interval_number > 0))) {
      return $scope.membershipPlan.allow_recurring_bookings = true;
    }
  };
  $scope.save = function() {
    prefillAllowRecurringBookings();
    return MembershipPlanService.validate($scope.membershipPlan).then(function() {
      loadingAnimation.show();
      return MembershipPlans.post($scope.membershipPlan).then(function() {
        flash.success = `${$scope.membershipPlan.label} saved`;
        return $state.go('^.list');
      }, function(response) {
        $scope.membershipPlan.errors = response.data.errors;
        flash.error = "Create failed. Please fix the errors below";
        return loadingAnimation.hide();
      });
    });
  };
  $scope.isFormValid = function() {
    var plan;
    plan = $scope.membershipPlan;
    return plan.classes_unlimited || isInteger(plan.classes_limit);
  };
  return $scope.cancel = function() {
    return $state.go('^.list');
  };
}]);
